var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Links"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.632 19.6344H17.2624V15.9224C17.2624 15.0368 17.244 13.8976 16.0272 13.8976C14.792 13.8976 14.6032 14.8608 14.6032 15.8568V19.6344H12.2344V12H14.5096V13.04H14.5408C14.8584 12.44 15.632 11.808 16.7872 11.808C19.188 11.808 19.632 13.3872 19.632 15.444V19.6344ZM9.5576 10.9552C8.7944 10.9552 8.1816 10.3384 8.1816 9.5792C8.1816 8.82 8.7952 8.2032 9.5576 8.2032C9.92254 8.2032 10.2725 8.34817 10.5306 8.60622C10.7886 8.86427 10.9336 9.21426 10.9336 9.5792C10.9336 9.94414 10.7886 10.2941 10.5306 10.5522C10.2725 10.8102 9.92254 10.9552 9.5576 10.9552ZM10.7448 19.6352H8.3688V12H10.7448V19.6344V19.6352ZM20.8168 6H7.1808C6.528 6 6 6.516 6 7.152V20.848C6 21.484 6.528 22 7.1808 22H20.8144C21.4664 22 22 21.4848 22 20.848V7.152C22 6.5168 21.4664 6 20.8144 6H20.8168Z",
    fill: "#D3DADD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedInIcon.64a1045c0513558513bbb2876549d0d1.svg";
export { ForwardRef as ReactComponent };